import { useNavigate } from "react-router-dom";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import po from './data/particle-options'


export default function Home() {
    const navigate = useNavigate();
    const particleOptions = po
    const particlesInit = async (main) => {
        // console.log(main);
        await loadFull(main);
    };

    const particlesLoaded = (container) => {
        // console.log(container);
    };

    return (
        <>
            <div className="absolute inset-x-0 shadow-xl bg-white bg-opacity-10 bg-clip-padding top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  z-10 flex content-center items-center flex-col border border-1 p-5 rounded-xl min-w-fit">
                <div className="flex-1 m-5 animate__animated animate__rubberBand">
                    <span className="box-decoration-slice bg-gradient-to-r from-indigo-600 to-pink-500 text-white text-5xl p-1 rounded-md">
                        Kaladont
                    </span>
                </div>
                <div className="flex-1">
                    <div className="flex flex-col">
                        <div className="flex-1 m-1">
                            <button onClick={() => navigate("/singleplayer/setup")} type="button" className="w-32 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Singleplayer</button>
                        </div>
                        <div className="flex-1 m-1">
                            <button type="button" className="w-32 text-white bg-blue-400 dark:bg-blue-500 cursor-not-allowed font-medium rounded-lg text-sm px-5 py-2.5 text-center" disabled>Multiplayer</button>
                        </div>
                    </div>
                </div>
            </div>

            <Particles
                id="tsparticles"
                init={particlesInit}
                loaded={particlesLoaded}
                options={particleOptions}
            />

        </>
    )
}